module.exports = __webpack_public_path__ + "media/images/common/medium_on-dba881fa592991e2b6f6caf34a3e2eb9.gif";